import { Modal } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components'
import { dimens } from '../shared-constants/dimens'
import { colors } from '../shared-constants/colors'
import { icons } from '../shared-asstes/icons'
import { fontSize } from '../shared-constants/fonts'

export const ConfirmModalContext = React.createContext({
  component: undefined,
  refresh: false,
  eventCach: null,
  setEventCache: () => {},
  setComponent: (component) => {},
  show: () => {},
  hide: () => {},
  title: '',
  setTitle: (title) => {},
  description: '',
  setDescription: (description) => {},
  setClosable: (closable) => {},
  setWidth: (width) => {},
})

const ConfirmModalProvider = (props) => {
  const [isShow, setShow] = useState(false)
  const [modalComponent, setModalComponent] = useState()
  const [eventCach, setEventCache] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [customWidth, setCustomWidth] = useState('90%')
  const [closable, setClosable] = useState(true)

  const show = () => {
    setShow(true)
  }

  const destroyModal = () => {
    setShow(false)
    setModalComponent(null)
    setClosable(true)
  }

  const hide = () => {
    destroyModal()
    setRefresh(!refresh)
    setClosable(true)
    // setCustomWidth(447);
  }

  return (
    <ConfirmModalContext.Provider
      value={{
        eventCach,
        setEventCache,
        setComponent: setModalComponent,
        component: modalComponent,
        hide,
        show,
        refresh,
        setTitle,
        setDescription,
        setWidth: setCustomWidth,
        setClosable: setClosable,
      }}
    >
      {props.children}
      <CustomModal
        className='confirm-modal fit-width'
        onCancel={hide}
        footer={null}
        width='100%'
        keyboard={true}
        centered={true}
        open={isShow}
        closable={closable}
        maskClosable={closable}
        destroyOnClose={true}
        title={title}
        closeIcon={<img src={icons.CLOSE} alt='close-icon' />}
        zIndex={2000}
      >
        <Description>{description}</Description>
        {modalComponent}
      </CustomModal>
    </ConfirmModalContext.Provider>
  )
}

export const ModalContextConsumer = ConfirmModalContext.Consumer

export default ConfirmModalProvider

const CustomModal = styled(Modal)`
  .ant-modal-title {
    padding-bottom: ${dimens.SPACING_M} !important;
    border-bottom: 1px solid ${colors.stroke2} !important;
  }
  .ant-modal-content {
    border-radius: ${dimens.BORDER_RADIUS_8} !important;
  }
  .ant-modal-title {
    text-align: center !important;
  }
  .ant-modal-header {
    border-bottom: 0 !important;
    background: none !important;
    padding-bottom: 0 !important;
  }
  .ant-modal-body {
    padding-top: 0 !important;
    padding-bottom: ${dimens.SPACING_M} !important;
  }
`

const Description = styled.p`
  text-align: center;
  font-size: ${fontSize.NORMAL};
  margin: ${dimens.SPACING_M} 0;
  line-height: ${dimens.LINE_HEIGHT_LARGE};
`
